module.exports = __webpack_public_path__ + "img/wallet.3f293e5b.svg";